import {
  collection,
  doc,
  setDoc,
  deleteDoc,
  onSnapshot,
  serverTimestamp,
  type Unsubscribe,
} from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { useRoutineStore } from '@/stores/routineStore';
import type { Routine } from '@/types';
import { toDate } from './firestoreDate';
import { logSyncError } from './syncErrors';

function routinesCol(uid: string) {
  return collection(db, 'users', uid, 'routines');
}

export function startRoutineSync(uid: string): Unsubscribe {
  return onSnapshot(
    routinesCol(uid),
    (snap) => {
      const routines: Routine[] = snap.docs.map((d) => {
        const data = d.data();
        const routine: Routine = {
          id: d.id,
          name: data.name as string,
          days: (data.days as Routine['days']) ?? [],
          steps: (data.steps as Routine['steps']) ?? [],
          createdAt: toDate(data.createdAt),
          updatedAt: toDate(data.updatedAt),
        };

        if (data.startTimeHHMM !== undefined) routine.startTimeHHMM = data.startTimeHHMM as string;

        return routine;
      });
      useRoutineStore.setState({ routines });
    },
    logSyncError('routineSync', uid),
  );
}

export async function writeRoutine(uid: string, routine: Routine): Promise<void> {
  const { id, ...rest } = routine;
  await setDoc(doc(routinesCol(uid), id), { ...rest, serverUpdatedAt: serverTimestamp() });
}

export async function deleteRoutine(uid: string, routineId: string): Promise<void> {
  await deleteDoc(doc(routinesCol(uid), routineId));
}
